import { render, staticRenderFns } from "./ItrRequest.vue?vue&type=template&id=16ec0928"
import script from "./ItrRequest.vue?vue&type=script&lang=js"
export * from "./ItrRequest.vue?vue&type=script&lang=js"
import style0 from "./ItrRequest.vue?vue&type=style&index=0&id=16ec0928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports